import React from "react";
import { ListItemText, ListItem } from "@material-ui/core";
import TouchRipple from "@material-ui/core/ButtonBase/TouchRipple";
import styled from "styled-components";
import { inject, observer } from "mobx-react";
import { IValuesStore } from "@src/Stores/Values/types";
import { Values } from "@src/Tools/Values";

const STListItem = styled(ListItem)`
  margin-top: auto;
`;

interface IProps {
  values?: IValuesStore;
}

@inject("values")
@observer
export default class VersionMenuItem extends React.Component<IProps> {
  render() {
    const text: string = `${Values.getLocalizationValue("applicationName")} v${
      this.props.values.version
    }`;

    return (
      <STListItem>
        <ListItemText secondary={text} />
        <TouchRipple />
      </STListItem>
    );
  }
}
